import React, { useEffect, useState } from 'react';
import { useCases } from '../../utils/paymentUseCases';
import Icon from '../../common/components/Icon';
import { PaymentNextStepsProps } from '../types/Payment';
import { useTranslations } from '../../localization/useTranslations';

const PaymentNextSteps: React.FC<PaymentNextStepsProps> = ({ code, payment_gateway, type, gift_code }) => {
  const [sections, setSections] = useState<any[]>([]);
  const translations = useTranslations();

  useEffect(() => {
    // Function to check visibility based on use cases
    const isVisible = (useCaseIds: number[]) => {
      return useCaseIds.some((id) => {
        const useCase = useCases.find((uc) => uc.id === id);
        return (
          useCase && useCase.code === code && useCase.payment_gateway.includes(payment_gateway) && useCase.type === type
        );
      });
    };

    if (window.forbes_sales_funnel && window.forbes_sales_funnel.list_of_steps) {
      const updatedSections = window.forbes_sales_funnel.list_of_steps.map((step, index) => ({
        title: step.step_title,
        content: step.step_description,
        linkLabel: step.link_label,
        downloadLink: step.url.includes('{couponCode}') ? step.url.replace('{couponCode}', gift_code) : step.url,
        isVisible: isVisible(step.visibility_conditions.map(Number)),
      }));
      setSections(updatedSections);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code, payment_gateway, type]);

  // Check if any section is visible
  const anySectionVisible = sections?.some((section) => section.isVisible);
  const myAccountSlug = window.myAccountPageSlug || 'my-account';

  return (
    <>
      {anySectionVisible && (
        <div className="section section--information">
          <h4 className="section__title">{translations?.paymentSummary?.nextStepsTitle || 'Next steps'}</h4>
          <div className="section__wrapper">
            {sections
              ?.filter((section) => section.isVisible)
              .map((section, index) => (
                <div className="section__box" key={index}>
                  <div className="section__content">
                    <h5 className="section__subtitle">
                      {index + 1}. {section.title}
                    </h5>
                    <div className="section__description basic-14">
                      <div dangerouslySetInnerHTML={{ __html: section.content }} />
                    </div>
                    {section.linkLabel && section.downloadLink && (
                      <a
                        href={section.downloadLink}
                        className="section__link section__link--download link--icon link__icon--before link link--medium"
                      >
                        <Icon name="document" size="small" />
                        {section.linkLabel}
                      </a>
                    )}
                  </div>
                </div>
              ))}
            {type === 'business' && payment_gateway.includes('gopay') ? (
              <a
                href={`/${myAccountSlug}/#/${translations?.route?.subscriptions}/`}
                className="button button--medium button--primary"
              >
                {translations?.paymentSummary?.goActivateButton || 'Go activate'}
              </a>
            ) : null}
          </div>
        </div>
      )}
    </>
  );
};

export default PaymentNextSteps;
